<template>
    <div v-for="(day, dayIndex) in daysData" :key="day.key"
         class="days-tasks-table">
        <v-row class="mt-12">
            <v-col cols="12" sm="6" md="4" xl="3"
                   class="droppable"
                   @drop="onDrop($event, day)"
                   @dragover.prevent
                   @dragenter.prevent>
                <div class="text-h6 text-primary">
                    {{getDate(day.date)}}
                </div>
            </v-col>
            <v-col cols="12" sm="5" md="3" xl="2">
                <v-btn @click="createOrDelegateTask(day.date)"
                       class="w-100"
                       color="lonely"
                       variant="flat">Создать задачу</v-btn>
            </v-col>
            <v-col cols="12" sm="5" md="3" xl="2">
                <v-btn @click="generateTask(day.date)"
                       class="w-100"
                       color="lonely"
                       variant="flat">Сгенерировать задачу</v-btn>
            </v-col>
        </v-row>
        <v-row v-if="day.dayTasks && day.dayTasks.length > 0">
            <v-col class="pb-0">
                <v-container class="text-primary pa-0">
                    <div v-for="task in day.dayTasks" :key="task.id"
                         @dragstart="onDragStart($event, task, dayIndex)"
                         @drop="onDrop($event, day, task)"
                         @dragover.prevent
                         @dragenter.prevent
                         draggable="true"
                         class="draggable droppable">
                        <DayTaskRow :day-task="task"
                                    @upsertDayTask="upsertDayTask($event)" />
                    </div>
                </v-container>
            </v-col>
        </v-row>
        <v-row v-if="showDayResult && !isFutureDate(day.date)">
            <v-col>
                <DayResultCard :modelValue="day.dayResult"
                               @update:modelValue="upsertDayResult($event)"
                               :show-text="showDayResultText"
                               :show-rating="showDayResultRating" />
            </v-col>
        </v-row>
    </div>

    <v-dialog v-model="showGenerateDialog"
              class="generetion-task-dialog"
              min-width="300"
              width="600"
              transition="dialog-bottom-transition">
        <v-card class="date-time-form text-primary ma-0">
            <v-card-title class="mb-4">
                Сгенерировать задачу
            </v-card-title>

            <v-card-text class="pa-4 pt-0 pb-2 mt-n2">
                <v-btn @click="generateFoodTask(1)"
                       class="w-100 mb-2"
                       color="primary"
                       variant="outlined">
                    Блюдо на завтрак
                </v-btn>
                <v-btn @click="generateFoodTask(2)"
                       class="w-100 mb-2"
                       color="primary"
                       variant="outlined">
                    Блюдо на обед
                </v-btn>
                <v-btn @click="generateFoodTask(3)"
                       class="w-100 mb-2"
                       color="primary"
                       variant="outlined">
                    Блюдо на ужин
                </v-btn>
                <v-btn @click="generateDessertTask(1)"
                       class="w-100 mb-2"
                       color="primary"
                       variant="outlined">
                    Десерт на завтрак
                </v-btn>
                <v-btn @click="generateDessertTask(2)"
                       class="w-100 mb-2"
                       color="primary"
                       variant="outlined">
                    Десерт на обед
                </v-btn>
                <v-btn @click="generateDessertTask(3)"
                       class="w-100 mb-2"
                       color="primary"
                       variant="outlined">
                    Десерт на ужин
                </v-btn>
                <v-btn @click="generateHobbyTask(true, true)"
                       class="w-100 mb-2"
                       color="primary"
                       variant="outlined">
                    Хобби любое
                </v-btn>
                <v-btn @click="generateHobbyTask(true, false)"
                       class="w-100 mb-2"
                       color="primary"
                       variant="outlined">
                    Хобби в помещении
                </v-btn>
                <v-btn @click="generateHobbyTask(false, true)"
                       class="w-100 mb-2"
                       color="primary"
                       variant="outlined">
                    Хобби на улице
                </v-btn>
                <v-btn @click="generateSportTask(true, true)"
                       class="w-100 mb-2"
                       color="primary"
                       variant="outlined">
                    Спортивная активность любая
                </v-btn>
                <v-btn @click="generateSportTask(true, false)"
                       class="w-100 mb-2"
                       color="primary"
                       variant="outlined">
                    Спортивная активность в помещении
                </v-btn>
                <v-btn @click="generateSportTask(false, true)"
                       class="w-100 mb-2"
                       color="primary"
                       variant="outlined">
                    Спортивная активность на улице
                </v-btn>
            </v-card-text>

            <v-card-actions class="pt-0 pr-4 pb-4">
                <v-spacer />
                <v-btn color="secondary"
                       variant="elevated"
                       @click="showGenerateDialog = false">Отменить</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="showCreateOrDelegateDialog"
              class="creation-task-dialog"
              min-width="300"
              width="600"
              transition="dialog-bottom-transition">
        <v-card class="date-time-form text-primary ma-0">
            <v-card-title class="mb-4">
                Создать задачу
            </v-card-title>

            <v-card-text class="pa-4 pt-0 pb-2 mt-n2">
                <v-btn @click="createTask"
                       class="w-100 mb-2"
                       color="primary"
                       variant="outlined">
                    Создать для себя
                </v-btn>
                <v-btn @click="delegateTask"
                       class="w-100 mb-2"
                       color="primary"
                       variant="outlined">
                    Делегировать другому пользователю
                </v-btn>
            </v-card-text>

            <v-card-actions class="pt-0 pr-4 pb-4">
                <v-spacer />
                <v-btn color="secondary"
                       variant="elevated"
                       @click="showCreateOrDelegateDialog = false">Отменить</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <SelectGroupsMemberDialogs v-model="showDelegateDialog"
                               :groups="userGroups"
                               :filter-users-ids="[userId]"
                               @select:member="delegateToUser($event)" />

    <CreateDayTaskDialog v-if="showCreateDialog"
                         :text="newDayTaskText"
                         :date="newDayTaskDate"
                         :show-regenerate-button="showRegenerateButton"
                         @regenerate:dayTask="regenerateFunction"
                         @hide="showCreateDialog = false"
                         @create:dayTask="upsertDayTask($event)" />
</template>

<script>
    import SelectGroupsMemberDialogs from "@/components/SelectGroupsMemberDialogs.vue";
    import CreateDayTaskDialog from "@/components/client/day_tasks/CreateDayTaskDialog.vue";
    import DayTaskRow from "@/components/client/day_tasks/DayTaskRow.vue";

    import DayResultCard from "@/components/client/day_results/DayResultCard.vue";

    import { mapState } from "vuex";
    import { DateTime } from "luxon";

    export default {
        components: {
            SelectGroupsMemberDialogs,
            CreateDayTaskDialog,
            DayTaskRow,
            DayResultCard
        },

        data() {
            return {
                showGenerateDialog: false,

                showCreateOrDelegateDialog: false,
                showCreateDialog: false,
                showDelegateDialog: false,
                newDayTaskDate: null,
                newDayTaskText: null,

                showRegenerateButton: false,
                regenerateFunction: null,

                delegate: false,
                selectedUser: null,

                daysData: []
            };
        },

        created() {
            this.loadDaysData();
        },

        computed: {
            ...mapState([
                "userName", "userId",
                "userGroups",
                "currentLocale",
                "currentDateTime", "selectedDateTime", "startDateTime", "endDateTime"
            ]),

            showDayResultText() {
                return this.$store.state.clientSettings?.showDayResultText ?? false;
            },
            showDayResultRating() {
                return this.$store.state.clientSettings?.showDayResultRating ?? false;
            },
            showDayResult() {
                return this.showDayResultText === true
                    || this.showDayResultRating === true;
            },

            isDateRange() {
                return this.startDateTime && this.endDateTime;
            },
            selectedDateTimeRange() {
                if (!this.isDateRange) {
                    return null;
                }

                return {
                    startDate: this.startDateTime,
                    endDate: this.endDateTime
                };
            },

            datesRange() {
                return this.$store.getters.datesRange;
            }
        },        

        watch: {
            selectedDateTime() {
                this.loadDaysData();
            },

            selectedDateTimeRange() {
                this.loadDaysData();
            }
        },

        methods: {
            onDragStart(event, task, dayIndex) {
                event.dataTransfer.dropEffect = "copy";
                event.dataTransfer.effectAllowed = "move";
                event.dataTransfer.setData("taskId", task.id.toString());
                event.dataTransfer.setData("dayIndex", dayIndex.toString());
            },

            onDrop(event, day, task) {
                const taskId = parseInt(event.dataTransfer.getData("taskId"));
                const dayIndex = parseInt(event.dataTransfer.getData("dayIndex"));
                const movedTask = this.daysData[dayIndex].dayTasks.find(t => t.id === taskId);

                if (!task) {
                    movedTask.dateAndTime.taskNumber = 1;
                } else if (!day.date.hasSame(movedTask.dateAndTime.date, "day")) {
                    movedTask.dateAndTime.taskNumber = task.dateAndTime.taskNumber + 1;
                } else if (movedTask.dateAndTime.taskNumber > task.dateAndTime.taskNumber) {
                    movedTask.dateAndTime.taskNumber = task.dateAndTime.taskNumber;
                } else {
                    movedTask.dateAndTime.taskNumber = task.dateAndTime.taskNumber + 1;
                }

                movedTask.dateAndTime.date = day.date;

                this.upsertDayTask(movedTask);
            },

            generateTask(date) {
                this.newDayTaskDate = date;
                this.newDayTaskText = null;

                this.showCreateDialog = false;
                this.showGenerateDialog = true;
            },

            generateSportTask(availableIndoors, availableOutside) {
                this.regenerateFunction =
                    () => this.generateSportTask(availableIndoors, availableOutside);

                this.$store.state.dayService
                    .getRandomSport({
                        availableIndoors: availableIndoors,
                        availableOutside: availableOutside
                    })
                    .then(response => {
                        if (!response.data) {
                            this.$store.commit("error", "Нет подходящей спортивной активности");
                            return;
                        }

                        this.addDayTask(this.newDayTaskDate, "Спортивная активность: " + response.data?.name);
                    });
            },

            generateHobbyTask(availableIndoors, availableOutside) {
                this.regenerateFunction =
                    () => this.generateHobbyTask(availableIndoors, availableOutside);

                this.$store.state.dayService
                    .getRandomHobby({
                        availableIndoors: availableIndoors,
                        availableOutside: availableOutside
                    })
                    .then(response => {
                        if (!response.data) {
                            this.$store.commit("error", "Нет подходящего хобби");
                            return;
                        }

                        this.addDayTask(this.newDayTaskDate, "Хобби: " + response.data?.name);
                    });
            },

            generateFoodTask(mealNumber) {
                this.regenerateFunction =
                    () => this.generateFoodTask(mealNumber);

                const text = mealNumber === 1
                    ? "Завтрак: "
                    : mealNumber === 2
                        ? "Обед: "
                        : mealNumber === 3
                            ? "Ужин: "
                            : "???: ";

                this.$store.state.dayService
                    .getRandomFood({
                        availableForBreakfast: mealNumber === 1,
                        availableForLunch: mealNumber === 2,
                        availableForDinner: mealNumber === 3
                    })
                    .then(response => {
                        if (!response.data) {
                            this.$store.commit("error", "Нет подходящего блюда");
                            return;
                        }

                        this.addDayTask(this.newDayTaskDate, text + response.data?.name);
                    });
            },

            generateDessertTask(mealNumber) {
                this.regenerateFunction =
                    () => this.generateDessertTask(mealNumber);

                const text = mealNumber === 1
                    ? "Десерт на завтрак: "
                    : mealNumber === 2
                        ? "Десерт на обед: "
                        : mealNumber === 3
                            ? "Десерт на ужин: "
                            : "???: ";

                this.$store.state.dayService
                    .getRandomDessert({
                        availableForBreakfast: mealNumber === 1,
                        availableForLunch: mealNumber === 2,
                        availableForDinner: mealNumber === 3
                    })
                    .then(response => {
                        if (!response.data) {
                            this.$store.commit("error", "Нет подходящего десерта");
                            return;
                        }

                        this.addDayTask(this.newDayTaskDate, text + response.data?.name);
                    });
            },

            isFutureDate(date) {
                return date.startOf("day") > this.currentDateTime.startOf("day");
            },

            createOrDelegateTask(date) {
                this.newDayTaskDate = date;
                this.newDayTaskText = null;

                this.showCreateOrDelegateDialog = true;
            },

            createTask() {
                this.showCreateDialog = true;
                this.showRegenerateButton = false;
                this.delegate = false;
            },

            delegateTask() {
                this.showDelegateDialog = true;
                this.delegate = true;
            },

            delegateToUser(user) {
                this.selectedUser = user;
                this.showCreateDialog = true;
                this.showRegenerateButton = false;
            },

            addDayTask(date, text = null) {
                this.newDayTaskDate = date;
                this.newDayTaskText = text;

                this.showCreateDialog = true;
                this.showRegenerateButton = true;
                this.delegate = false;
            },

            getDate(dateTime) {
                return dateTime.setLocale(this.currentLocale).toFormat("d MMMM (EEEE)");
            },

            upsertDayTask(dayTask) {
                const request = {
                    id: dayTask.id,
                    taskText: dayTask.taskText,
                    isCompleted: dayTask.isCompleted,
                    resultText: dayTask.resultText,
                    dateAndTime: {
                        date: dayTask.dateAndTime.date.toFormat("yyyy-MM-dd"),
                        startTime: dayTask.dateAndTime.startTime,
                        duration: dayTask.dateAndTime.duration,
                        endTime: dayTask.dateAndTime.endTime,
                        taskNumber: dayTask.dateAndTime.taskNumber
                    }
                };

                this.newDayTaskDate = null;
                this.newDayTaskText = null;
                this.showGenerateDialog = false;
                this.showDelegateDialog = false;
                this.showCreateDialog = false;
                this.showCreateOrDelegateDialog = false;

                if (!this.delegate || !this.selectedUser) {
                    this.$store.dispatch("upsertDayTask", request)
                        .then(response => {
                            if (response.data === true) {
                                this.loadDaysTasks();
                            }
                        });
                    return;
                }

                const initiatorTask = { ...request };
                const executorTask = { ...request };

                initiatorTask.taskText = `[для ${this.selectedUser.userName}] ` + request.taskText;
                this.$emit("upsertDayTask", initiatorTask);
                this.$store.dispatch("upsertDayTask", initiatorTask)
                    .then(response => {
                        if (response.data === true) {
                            this.loadDaysTasks();
                        }
                    });

                executorTask.taskText = `[от ${this.userName}] ` + request.taskText;
                this.$store.dispatch("delegateDayTask", {
                    task: executorTask,
                    userId: this.selectedUser.id
                });

                this.delegate = false;
                this.selectedUser = null;
            },

            upsertDayResult(dayResult) {
                const request = {
                    date: dayResult.date.toFormat("yyyy-MM-dd"),
                    result: dayResult.result,
                    rating: dayResult.rating
                };

                this.$store.dispatch("upsertDayResult", request)
                    .then(response => {
                        if (response.data === true) {
                            this.loadDaysResults();
                        }
                    });
            },

            loadDaysTasks() {
                this.loadDaysData(true, false);
            },

            loadDaysResults() {
                this.loadDaysData(false, true);
            },

            loadDaysData(loadDaysTasks = true, loadDaysResults = true) {
                const startDate = this.datesRange.startDate;
                const endDate = this.datesRange.endDate;

                if (loadDaysTasks && loadDaysResults) {
                    this.$store.dispatch("loadDaysTasks")
                        .then(() => {
                            this.$store.dispatch("loadHabits").then(() =>
                                this.$store.dispatch("loadDaysResults")
                                    .then(() => this.updateDaysData(startDate, endDate)));
                        });
                } else if (loadDaysTasks) {
                    this.$store.dispatch("loadDaysTasks")
                        .then(() => this.updateDaysData(startDate, endDate));
                } else if (loadDaysResults) {
                    this.$store.dispatch("loadDaysResults")
                        .then(() => this.updateDaysData(startDate, endDate));
                } else {
                    this.updateDaysData(startDate, endDate);
                }
            },

            updateDaysData(startDate, endDate) {
                const daysCount = endDate.diff(startDate, "days").days + 1;

                const daysData = [];

                for (let i = 0; i < daysCount; i++) {
                    const date = startDate.plus({ days: i });
                    const existingDayResult = this.$store.state.daysResults
                        .find(r => DateTime.fromISO(r.date).hasSame(date, "day"));

                    const dayResult = existingDayResult
                        ? {
                            date: DateTime.fromISO(existingDayResult.date),
                            result: existingDayResult.result,
                            rating: existingDayResult.rating
                        }
                        : {
                            date: date,
                            result: "",
                            rating: 0
                        };

                    const dayTasks = this.$store.state.daysTasks
                        .filter(t => DateTime.fromISO(t.dateAndTime.date).hasSame(date, "day"))
                        .map(t => ({
                            id: t.id,
                            taskText: t.taskText,
                            resultText: t.resultText,
                            isCompleted: t.isCompleted,
                            dateAndTime: {
                                date: DateTime.fromISO(t.dateAndTime.date),
                                startTime: t.dateAndTime.startTime,
                                endTime: t.dateAndTime.endTime,
                                duration: t.dateAndTime.duration,
                                taskNumber: t.dateAndTime.taskNumber
                            }
                        }))
                        .sort((t1, t2) => t1.dateAndTime.taskNumber - t2.dateAndTime.taskNumber);

                    daysData.push({
                        key: date.toFormat("yyyy-MM-dd"),
                        date: date,
                        dayTasks: dayTasks,
                        dayResult: dayResult
                    });
                }

                this.daysData = daysData;
            }
        }
    };
</script>

<style lang="scss">
    .days-tasks-table {
    }
</style>